import React, { useEffect } from 'react'

import HpHero from '~/components/features/home/hpHero'
import HpKeyFigures from '~/components/features/home/hpKeyFigures'
import HpInfos from '~/components/features/home/hpInfos'
import PushContent from '~/components/core/pushContent'
import NewsroomFeatured from '~/components/core/newsroomFeatured'
import ImageTextProfile from '~/components/slices/imageTextProfile'

interface HomeLayoutProps {
  mainDatas: Queries.HomePageQuery['homepage']
  news: Queries.HomePageQuery['news']['nodes']
  events: Queries.HomePageQuery['events']['nodes']
}

export const HomeLayout = ({ mainDatas, news, events }: HomeLayoutProps) => {
  return (
    <div className="w-full">
      <HpHero data={mainDatas} />
      <NewsroomFeatured events={events} news={news} type="hp" />

      {((mainDatas?.pushPage &&
        !mainDatas?.pushPage.fields &&
        mainDatas?.pushPage.content) ||
        (mainDatas?.pushPage &&
          mainDatas?.pushPage.fields &&
          mainDatas?.pushPage.fields.content)) && (
        <div className="slice">
          <ImageTextProfile data={mainDatas.pushPage} />
        </div>
      )}
      <HpInfos data={mainDatas} />
      {/* <HpKeyFigures data={mainDatas} />
      <PushContent data={mainDatas.pushContent} type="hp" /> */}
    </div>
  )
}
